
const enviornment = 'uat'; // prod/uat/dev

let api;
if (enviornment === 'uat') {
    api = {
        validatetoken: 'https://ainxt.nomineeoptout.uat.ainxtkyc.com/validatetoken',
        getusercount: 'https://fn1s5ch3w0.execute-api.ap-south-1.amazonaws.com/default/getusercount',
        verify_nominee_optout: "https://ainxt.nomineeoptout.uat.ainxtkyc.com/verify_nominee_optout",

        x_api_key: 'dgHnYHpcBxajmdmlWymPO40PVFzaTkvq75hHHj5m',
        authorizationToken: 'M716Cq1I2qDUTh1z',
        usercount: true
    }
}

if (enviornment === 'prod') {
    api = {
        validatetoken: 'https://ainxt.nomineeoptout.prod.ainxtkyc.com/validatetoken',
        getusercount: 'https://kibdc3r4gf.execute-api.ap-south-1.amazonaws.com/default/getusercount',
        verify_nominee_optout: "https://ainxt.nomineeoptout.prod.ainxtkyc.com/verify_nominee_optout",

        x_api_key: 'KEICbyyzfnPmpxefSyyDf7Px5XJfol5bJBnklbj0',
        authorizationToken: 'nYB3odfPm6oFR3v2',
        usercount: false
    }
}

export default api;